import React from "react"
import Select from "react-select"


class SelectField extends React.Component {
    componentDidMount() {
        if (this.props.options.length == 1 && this.props.value == "") {
            //console.log('Updating', this.props)
            this.handleChange({ value: this.props.options[0].value })
        }
    }
    componentDidUpdate() {
		if(this.props.options.length == 1 && this.props.value == '') {
			//console.log('Updating', this.props)
			this.handleChange({value: this.props.options[0].value})
		}
    }

    handleChange = value => {
		//console.log('Changing', this.props, value)
        if (value === null) {
            value = {
                value: "",
            }
        }
        //console.log(value)
        if (this.props.row) {
            // THis is a traffic row
            var val = ""
            if (isNaN(value.value)) {
                val = value.value
            } else if (typeof value.value === "boolean") {
                val = value.value
            } else {
                val = parseInt(value.value)
			}
            //var val = (isNaN(value.value) ? value.value : parseInt(value.value))
            this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`, val)
        } else {
            this.props.onChange(this.props.name, value.value)
        }
    }

    handleBlur = (v, f) => {
        if (this.props.row) {
            // this is a row e.g traffic
            this.props.onBlur(`rows[${this.props.rowIndex}][${this.props.name}]`, true)
        } else {
            this.props.onBlur(this.props.name, true)
        }
    }

    render() {
        //console.log(this.props)
        return (
            <Select
                value={this.props.value}
                id={this.props.name}
                options={this.props.options}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
            />
        )
    }
}

export default SelectField
